(function () {
  'use strict';

  function activateProductTab(tab) {
    var navigation = tab.closest('.tabs-nav');
    var cardSection = navigation && navigation.closest('.card__section');
    var content = cardSection && cardSection.querySelector('.tabs-content');

    if (!navigation || !content) {
      return;
    }

    var tabs = Array.from(navigation.querySelectorAll('li'));
    var panels = Array.from(content.children);
    var activeIndex = tabs.indexOf(tab);

    tabs.forEach(function (item, index) {
      item.classList.toggle('active', index === activeIndex);
    });

    panels.forEach(function (panel, index) {
      panel.classList.toggle('active', index === activeIndex);
      panel.hidden = index !== activeIndex;
    });
  }

  function initializeProductTabs(root) {
    root.querySelectorAll('.tabs-nav').forEach(function (navigation) {
      var firstTab = navigation.querySelector('li');
      if (firstTab) {
        activateProductTab(firstTab);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.tabs-nav li');

    if (tab) {
      activateProductTab(tab);
      return;
    }

    var addButton = event.target.closest('.kg-product-form__add-button');
    if (!addButton) {
      return;
    }

    var groupedBuy = addButton.closest('[data-kg-grouped-buy]');
    if (!groupedBuy || addButton.disabled) {
      return;
    }

    var errorBox = groupedBuy.querySelector('.kg-error-msg-box');
    var errorMessage = errorBox && errorBox.querySelector('.kg-error');
    var quantityInputs = Array.from(groupedBuy.querySelectorAll('.kg-group-qty'));
    var items = [];
    var totalQuantity = 0;

    quantityInputs.forEach(function (input) {
      input.classList.remove('kg-error');
    });

    groupedBuy.querySelectorAll('.kg-group-product').forEach(function (row) {
      var input = row.querySelector('.kg-group-qty');
      var quantity = input ? parseInt(input.value, 10) : 0;

      if (Number.isFinite(quantity) && quantity > 0) {
        items.push({
          id: parseInt(row.dataset.id, 10),
          quantity: quantity
        });
        totalQuantity += quantity;
      }
    });

    if (items.length === 0) {
      if (errorMessage) {
        errorMessage.textContent = 'Please specify the quantity of product(s).';
      }
      if (errorBox) {
        errorBox.hidden = false;
      }
      quantityInputs.filter(function (input) {
        return input.type !== 'hidden';
      }).forEach(function (input) {
        input.classList.add('kg-error');
      });
      return;
    }

    if (errorBox) {
      errorBox.hidden = true;
    }

    addButton.disabled = true;
    document.dispatchEvent(new Event('theme:loading:start'));

    var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'The selected products could not be added to the cart.');
        }
        return data;
      });
    }).then(function () {
      quantityInputs.forEach(function (input) {
        input.value = 0;
      });

      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity: totalQuantity,
          productAdded: true,
          button: addButton
        }
      }));
    }).catch(function (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message;
      }
      if (errorBox) {
        errorBox.hidden = false;
      }
      document.dispatchEvent(new Event('theme:loading:end'));
    }).finally(function () {
      addButton.disabled = false;
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeProductTabs(document);
    });
  } else {
    initializeProductTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeProductTabs(event.target);
  });
})();
